<template>
  <div>
    <v-layout>
      <v-flex lg10 md9 sm12>
        <v-btn :to="{name: 'celendar-new'}" color="green">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn :to="{name: 'calendar-history'}">
          <v-icon>history</v-icon>
        </v-btn>
      </v-flex>

      <v-flex lg2 md3 sm12>
        <v-switch v-model="useUserCalendarColor" :label="$t('calendar.base.color_by_user')" hide-details
                  @change="switchCalendarColor"></v-switch>
        <v-switch v-model="weekCalendar" hide-details label="Kalendarz tygodniowy"
                  @change="switchWeekCalendar"></v-switch>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex lg8 md6 sm12>
        <SearchSort :sort-disable="true" @search="($event) => {search($event); filterUsers()}"></SearchSort>
      </v-flex>
      <v-flex lg4 md6 sm12>
        <v-select v-model="selectedUser" :items="users" chips item-text="surname" item-value="id"
                  label="Wyszukaj wydarzenia dla użytkowników:" multiple @change="filterUsers">
          <template v-slot:item="props">
            {{ props.item.name }} {{ props.item.surname }}
          </template>
          <template v-slot:selection="props">
            {{ props.item.name }} {{ props.item.surname }}
          </template>
        </v-select>
      </v-flex>
    </v-layout>


    <v-dialog width="1000" v-model="showAddEvent">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('calendar.base.select_event_type') }}
        </v-card-title>
        <v-container>
          <v-select v-model="newEventType" :items="schemas" item-text="name" item-value="id"
                    :label="$t('calendar.base.event_type')"></v-select>
          <v-btn color="green" @click="redirectToCreateEvent">OK</v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog width="80%" v-model="showHistoryEvent">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('calendar.base.event_history') }} : {{ historyEvent.title }}
        </v-card-title>
        <v-container>
          <History :calendar-id="historyEvent.id" :users="users"></History>
        </v-container>
      </v-card>
    </v-dialog>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <div v-else id="calednar">
      <v-layout style="margin-top: 3rem" wrap>
        <v-flex class="pa-3 mb-3 feature-pane" lg3 sm12>
          <v-btn absolute color="primary" fab left outline small @click="$refs.calendar.prev()">
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>
          <v-btn absolute color="primary" fab outline right small @click="$refs.calendar.next()">
            <v-icon dark>
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div style="text-align: center;font-size: 1.5rem;">{{ getDisplayData(model) }}</div>
      <v-container>
        <div min-height="600px">
              <v-layout>
                <v-flex>
                  <div v-if="mountedDone" style="min-height:500px">
                    <v-calendar
                        :now="today"
                        :value="today"
                        v-model="model"
                        color="primary"
                        :type="weekCalendar ? 'week' : 'month'"
                        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                        @click:date="showPreAddEvent"
                        ref="calendar"
                        :dark="false"
                        locale="pl-Pl"
                        style="min-height: 400px"
                    >

                      <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                        <template v-for="event in eventsMap[date]">
                          <div :key="event.title"
                               :style="getWeekCalendarStyle(event, eventsMap[date], timeToY)">
                            <CalendarItem :key="event.id"
                                          :event="event"
                                          :height="minutesToPixels(event.duration)"
                                          :useUserCalendarColor="useUserCalendarColor"
                                          @delete-event="()=> deleteEvent(event)"
                                          @show-history="()=> history(event)"/>
                          </div>
                        </template>
                      </template>

                      <template v-slot:day="{ date }">
                        <template v-for="event in eventsMap[date]">
                          <CalendarItem :key="event.id"
                                        :event="event"
                                        :useUserCalendarColor="useUserCalendarColor"
                                        @delete-event="()=> deleteEvent(event)" @show-history="()=> history(event)"/>
                        </template>
                      </template>

                    </v-calendar>
                  </div>
                </v-flex>
              </v-layout>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import History from './History'
import Cookies from 'js-cookie'
import CalendarItem from "@/components/calendar/CalendarItem.vue"
import SearchSort from "@/components/common/SearchSort.vue"

export default {
  name: "CalednarIndex",
  components: {History, CalendarItem, SearchSort},
  data() {
    return {
      selectedUser: null,
      searchVal: "",
      showHistoryEvent: false,
      historyEvent: {},
      useUserCalendarColor: false,
      users: [],
      today: new Date().toISOString().slice(0, 19).replace('T', ' '),
      allEvents: [],
      eventsT: [],
      loading: true,
      mountedDone: false,
      model: null,
      showAddEvent: false,
      schemas: [],
      newEventDate: null,
      newEventType: -1,
      weekCalendar: false
    }
  },
  computed: {
    eventsMap() {
      const map = {}
      this.eventsT.forEach(e => {
        try {
          e.duration = (Date.parse(e.finishedAt) - Date.parse(e.scheduledAt)) / (60 * 1000)
          e.time = e.scheduledAt.split(" ")[1] // new Date(e.scheduledAt).getHours() + ":" + new Date(e.scheduledAt).getMinutes()
        } catch (e) {
          e.time = "00:00"
        }
      })

      this.eventsT.forEach(e => (map[e.scheduledAt.split(" ")[0]] = map[e.scheduledAt.split(" ")[0]] || []).push(e))
      for (let key in map) {
        map[key] = map[key].reverse()
      }

      return map
    }
  },
  created() {
    this.useUserCalendarColor = Cookies.get('useUserCalendarColor') === 'true'
    this.weekCalendar = Cookies.get('useWeekCalendar') === 'true'
    let schemas = this.$http.get('schemas')
    let calendarSchemas = this.$http.get('calendar/schemas')
    let users = this.$http.get('/users')

    Promise.all([schemas, calendarSchemas, users]).then(data => {
      let idSchemas = data[1].data.map(cs => cs.schema_id)
      this.schemas = data[0].data.filter(schema => idSchemas.includes(schema.id))
      this.schemas = [{id: 0, name: this.$t('calendar.base.standard_event')}].concat(this.schemas)
      this.users = data[2].data
    }).catch(() => {
      Messenger.emitError(this.$t('calendar.base.cannot_download_data'))
    })
  },
  mounted() {
    this.loading = true
    this.$http.get('calendar').then(data => {
      const map = {}
      this.eventsT = data.data
      this.allEvents = data.data
      data.data.forEach(e => (map[e.scheduledAt.split(" ")[0]] = map[e.scheduledAt.split(" ")[0]] || []).push(e))
      this.loading = false
    }).catch(() => {
      Messenger.emitError(this.$t('calendar.base.cannot_download_data'))
    })
    this.mountedDone = true
  },
  methods: {
    filterUsers() {
      this.search({search: this.searchVal})

      if (this.selectedUser == null || this.selectedUser.length == 0) {
        return
      }

      this.eventsT = this.eventsT.filter(el => Array.isArray(el.users) &&
          el.users.some(userId => this.selectedUser.includes(Number(userId))))
    },
    search({search}) {
      this.searchVal = search.toLowerCase()
      this.eventsT = this.allEvents.filter(el => el.title.toLowerCase().includes(this.searchVal) ||
          (el.description != null && el.description.toLowerCase().includes(this.searchVal)))
    },
    getWeekCalendarStyle(event, eventDays, timeToY) {
      let scheduledAt = new Date(event.scheduledAt)

      if (scheduledAt.getHours() > 0) {
        scheduledAt.setHours(scheduledAt.getHours() - 1)
      }

      let finishedAt = new Date(event.finishedAt)
      if (finishedAt.getHours() > 0) {
        finishedAt.setHours(finishedAt.getHours() + 1)
      }

      let colisions = eventDays.filter(e => (new Date(e.scheduledAt) <= finishedAt && new Date(e.finishedAt) >= scheduledAt) ||
          (new Date(e.scheduledAt)).getTime() == (new Date(event.scheduledAt)).getTime() ||
          (new Date(e.finishedAt)).getTime() == (new Date(event.finishedAt)).getTime())

      let width = 100 / (colisions.length == 0 ? 1 : colisions.length)
      let indexOf = colisions.indexOf(colisions.find(e => e.id == event.id))
      let margin = indexOf == -1 ? 0 : indexOf * width

      return {
        top: `${timeToY(event.time)}px`,
        position: 'absolute',
        width: `${width}%`,
        'left': `${margin}%`
      }
    },
    getDisplayData() {
      if (!this.model) {
        return new Date().toJSON().slice(0, 7)
      }
      return this.model.slice(0, 7)
    },
    switchCalendarColor($event) {
      Cookies.set('useUserCalendarColor', $event)
    },
    switchWeekCalendar($event) {
      Cookies.set('useWeekCalendar', $event)
    },
    deleteEvent(event) {
      this.eventsT = this.eventsT.filter(el => el.id != event.id)
    },
    history(calendarEvent) {
      this.historyEvent = calendarEvent
      this.showHistoryEvent = true
    },
    showPreAddEvent(date) {
      this.showAddEvent = true
      this.newEventDate = date
    },
    redirectToCreateEvent() {
      if (this.newEventType === -1) {
        Messenger.emitError(this.$t('calendar.base.select_event_type'))
        return
      }

      let queryParam = '?date=' + this.newEventDate.date

      if (this.newEventType === 0) {
        this.$router.push(`calendar/new/${queryParam}`)
        return
      }

      this.$router.push(`form/${this.newEventType}/fill/${queryParam}`)

    },
  }
}
</script>

<style scoped>

</style>